import React from 'react'
import { Tag } from 'antd'
import { STATUS_DISPLAY } from './listUtils'
import { LoyaltyMultiplierStatus } from './types'

interface MultiplierStatusTagProps {
  status: LoyaltyMultiplierStatus
}

export const MultiplierStatusTag = ({ status }: MultiplierStatusTagProps) => {
  const { label, color } = STATUS_DISPLAY[status]
  return (
    <Tag style={{ color, borderColor: color, background: 'transparent' }}>
      {label}
    </Tag>
  )
}
